import { combineReducers } from 'redux'
import _ from 'lodash'

import * as ediConfigsList from './list'
import * as getEdiConfig from './get'
import * as createEdiConfig from './create'
import * as editEdiConfig from './edit'
import * as deleteEdiConfig from './delete'

const slices = {
  ediConfigsList,
  getEdiConfig,
  createEdiConfig,
  editEdiConfig,
  deleteEdiConfig
}

const ediConfigTypes = _.mapValues(slices, (s) => s.slice.types)
const ediConfigActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const ediConfigSagas = _(slices).values().map('slice.sagas').flatten().value()
const ediConfigSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export { ediConfigTypes, ediConfigActions, ediConfigSagas, ediConfigSelectors }

export default combineReducers(reducers)
